import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { ArticleStipend } from './stipend.module';
import { ActivatedRoute } from '@angular/router';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';
import { MatTabBody } from '@angular/material/tabs';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-stipend',
  templateUrl: './stipend.component.html',
  styleUrls: ['./stipend.component.css'],
})
export class StipendComponent implements OnInit {
  financialList;
  branchList;
  closingDateList;
  userId;
  selectedFinancialYear;
  selectedBranch;
  selectedProfile;
  selectedClosing;
  routerURL;
  isMyStipendReport = false;
  userRole;
  accessResponse: any;

  reportList: ArticleStipend[];

  constructor(
    private masterDataService: MasterDataService,
    private router: ActivatedRoute,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.routerURL = this.router.snapshot.routeConfig.path;
    if (this.routerURL == 'my-stipend-report') {
      this.isMyStipendReport = true;
    }
    this.selectedFinancialYear = '';
    this.selectedBranch = '';
    this.selectedProfile = '1';
    this.selectedClosing = '';

    this.loadFinancialDetails();
  }
  loadFinancialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }
  onFinancialYearSlected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
        });
    }
  }

  showExportToExcelButton = false;
  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedBranch == null ||
      this.selectedBranch == undefined ||
      this.selectedBranch == '' ||
      this.selectedClosing == null ||
      this.selectedClosing == undefined ||
      this.selectedClosing == '' ||
      this.selectedProfile == null ||
      this.selectedProfile == undefined
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    if (!this.isMyStipendReport) {
      this.userId = 0;
      this.masterDataService
        .getStipendReport(
          this.selectedBranch.id,
          this.selectedClosing,
          this.selectedProfile,
          this.userId
        )
        .subscribe((res) => {
          console.log('reportlist', res);
          this.reportList = res;
          // this.showExportToExcelButton=true;
          if (this.reportList.length == 0) {
            this.showExportToExcelButton = false;
            this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
          } else {
            this.showExportToExcelButton = true;
          }

        });
    } else {
      this.userId = localStorage.getItem('id');
      console.log('userId', this.userId);
      this.masterDataService
        .getStipendReport(
          this.selectedBranch.id,
          this.selectedClosing,
          this.selectedProfile,
          this.userId
        )
        .subscribe((res) => {
          this.reportList = res;
          if (this.reportList.length == 0) {
            this.showExportToExcelButton = false;
            this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
          } else {
            this.showExportToExcelButton = true;
          }
        });
    }
  }
  exportToExcelClick() {
    if (!this.isMyStipendReport) {
      this.userId = 0;
      this.masterDataService
        .getStipendReportExportToExcel(
          this.selectedBranch.id,
          this.selectedClosing,
          this.selectedProfile,
          this.userId
        )
        .subscribe((resp: any) => {
          const blob = new Blob([resp]); // you can change the type
          var downloadURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = "ArticleStipendReport.xlsx";
          link.click();
        });
    } else {
      this.userId = localStorage.getItem('id');
      this.masterDataService
        .getStipendReportExportToExcel(
          this.selectedBranch.id,
          this.selectedClosing,
          this.selectedProfile,
          this.userId
        )
        .subscribe((resp: any) => {
          const blob = new Blob([resp]); // you can change the type
          var downloadURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = "MyArticleStipendReport.xlsx";
          link.click();
        });
    }
  }

  exportToPDFClick() {
    var body = [];
    body.push([{ text: '', colSpan: 4, fillColor: '#17a2b8 !important', color: 'white', fontSize: 14, bold: true }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: 'Period of Articleship	', colSpan: 3, fillColor: '#17a2b8 !important', color: 'white', fontSize: 14, bold: true }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: 'Penalty', colSpan: 2, fillColor: '#17a2b8 !important', color: 'white', fontSize: 14, bold: true }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }, { text: '', fillColor: '#17a2b8 !important' }]);
    body.push([{ text: 'Reporting Partner', style: 'headerStyle' },
    { text: 'Article name', style: 'headerStyle' },
    { text: 'ICAI Registration Date', style: 'headerStyle' },
    { text: 'Articleship End Date', style: 'headerStyle' },
    { text: 'Year', style: 'headerStyle' },
    { text: 'Month', style: 'headerStyle' },
    { text: 'Days', style: 'headerStyle' },
    { text: 'Amount Of Stipned', style: 'headerStyle' },
    { text: 'Late Diary Submission Penalty', style: 'headerStyle' },
    { text: 'Late Leave submission', style: 'headerStyle' },
    { text: 'Conveyance	', style: 'headerStyle' },
    { text: 'Scholarship', style: 'headerStyle' },
    { text: 'Advance Travelling Allowance', style: 'headerStyle' },
    { text: 'Total Travelling Amount	', style: 'headerStyle' },
    { text: 'Net Amount Payable', style: 'headerStyle' }])

    for (let i = 0; i < this.reportList.length; i++) {
      for (let j = 0; j < this.reportList[i].partner.length; j++) {
        for (let k = 0; k < this.reportList[i].partner[j].stipendDetails.length; k++) {
          var row = [{ text: this.reportList[i].partner[j].partnerFName + ' ' + this.reportList[i].partner[j].partnerLName },
          { text: this.reportList[i].partner[j].stipendDetails[k].firstName + ' ' + this.reportList[i].partner[j].stipendDetails[k].lastName },
          { text: this.reportList[i].partner[j].stipendDetails[k].icaiRegistrationDate == null ? '' : moment(this.reportList[i].partner[j].stipendDetails[k].icaiRegistrationDate).format('DD-MM-YYYY') },
          { text: this.reportList[i].partner[j].stipendDetails[k].articleshipEndDate == null ? '' : moment(this.reportList[i].partner[j].stipendDetails[k].articleshipEndDate).format('DD-MM-YYYY') },
          { text: this.reportList[i].partner[j].stipendDetails[k].year },
          { text: this.reportList[i].partner[j].stipendDetails[k].month },
          { text: this.reportList[i].partner[j].stipendDetails[k].days },
          { text: this.reportList[i].partner[j].stipendDetails[k].stipend },
          { text: this.reportList[i].partner[j].stipendDetails[k].diaryPenalty },
          { text: this.reportList[i].partner[j].stipendDetails[k].leavePenalty },
          { text: this.reportList[i].partner[j].stipendDetails[k].conveyance },
          { text: this.reportList[i].partner[j].stipendDetails[k].scholarship },
          { text: this.reportList[i].partner[j].stipendDetails[k].travelAdvance },
          { text: this.reportList[i].partner[j].stipendDetails[k].totalTravelAmount },
          { text: this.reportList[i].partner[j].stipendDetails[k].netPayableAmount }]
          body.push(row);
        }
      }
    }

    let docDefinition = {
      info: { title: 'Article Stipend Report' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: `${this.reportList.map(r => r.branch)}`, bold: true },
        {
          table: {
            headerRows: 1,
            widths: [50, 50, 50, 50, 15, 15, 20, 50, 70, 50, 30, 30, 50, 50, '*'],
            body: body
          },
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('ArticleStipendReport.pdf');
  }
}
